// extracted by mini-css-extract-plugin
export default {"main_sec":"style_main_sec__jGGEj","input_fields":"style_input_fields__lzd0F"};